/* eslint-disable max-len */
import React, { useContext, useEffect, useRef, useState } from "react"
import { Link, useLocation, useParams, useSearchParams, useNavigate } from "react-router-dom"
import TopHeader from "../../../components/TopHeader"
import { motion } from 'framer-motion'
import CustomOverlay from '../../../components/CustomOverLay'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen'
import { useGetPatientWellnessDetailsQuery, useViewPatientQuery } from "../../../features/patientSlice"
import GlobalContext from "../../../components/Context/GloablContext"
import ProviderList from "../ProviderList/ProviderList"
import { handleSidebarAnimation } from "../../../redux/commonSlice"
import { useDispatch, useSelector } from "react-redux"
import ViewPatient from "../../ManagePatient/ViewPatient"
import AnimatedModel from "../../../components/Animation/AnimatedModel"
import Toast from "../../../components/Toast"
import ConfirmationPrompt from "../../../components/ConfirmationPrompt"
import TextArea from "../../../components/TextArea"
import { useGetProviderAssociatedToPatientListModalQuery, useSendProviderAlertMutation } from "../../../features/dashBoardSlice"
import ProviderDropdown from "./dropdownProviderList"
import formatMobileNumber from "../../../CommonMethods/FormatMobileNumber"
import DeviceAlertList from "../AlertsList"
import ProviderAlertList from "../ProviderAlertList/ProviderAlertList"
import HelpGuideModal from "../../../components/HelpGuideModal"
import { useGetHelpGuideAdminQuery } from '../../../features/patientSlice'
import DeviceList from "../DeviceLIst/DeviceList"
import PermissionErrorEmptyScreen from "../../../components/Emptyscreenwithouttitle/PermissionErrorEmptyScreen"
import DeviceAlertDashboardSearch from "./AdvancedSearch"
import { setDeviceAlertDashboardSearch, resetDeviceAlertDashboardSearch, setDeviceAlertDashboardSearchApplied } from '../../../redux/deviceAlertDashboardSlice.js';


export default function ViewPatientAlertMainScreen() {
    const { id } = useParams()
    const navigate = useNavigate()
    const { isSideBar, setToastmessage, isAdvancedSearchOpen, setIsAdvancedSearchOpen } = useContext(GlobalContext)
    const deviceDashboardSearch = useSelector(state => state.deviceAlertDashboardSearchData);

    const [searchParams, setSearchParams] = useSearchParams()
    const dispatch = useDispatch()
    // const [patientTabName, setPatientTabName] = useState('device_alerts')
    const [patientTabName, setPatientTabName] = useState(() => {
        return searchParams.get('tabname') || 'device_alerts'; // Default to 'Graphs' only if tabname is missing
    });
    const location = useLocation()

    const [sendAlert] = useSendProviderAlertMutation()
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const [emptyField, setEmptyField] = useState(false)
    const [confirmation, setConfirmation] = useState(false)
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationTablestate, setConfirmationTableState] = useState(false)
    const [loading, setLoading] = useState(true)
    const [sendalertloading, setalertloading] = useState(false)
    const [datePartialFilled, setDatePartialFilled] = useState(false)
    const [isStateLoading, setIsStateLoading] = useState(false);
    const [isSortselected, setisSortSelected] = useState(false)

    const [sendalertDetails, setsendalertDetails] = useState({
        "alert_message": "",
        "alert_priority": "",
        "recepient_details": [],
    })
    const outsideClickRef = useRef();

    const { data, isFetching, status, error } = useViewPatientQuery(`${location?.pathname?.split('/')[2]}?action=view`, { refetchOnMountOrArgChange: true })
    const { data: wellnessDetails, isFetching: wellnessFetching, status: wellnessStatus, error: wellnessError } = useGetPatientWellnessDetailsQuery(location?.pathname?.split('/')?.[3])


    /* The above code snippet is using the React Query library to fetch data related to providers
    associated with a patient. It is using the `useGetProviderAssociatedToPatientListModalQuery` hook
    with the specified `id` parameter and options `{ refetchOnMountOrArgChange: true }`. */
    const { data: providerList, isFetching: providerfetching, isLoading: providerloading, status: providerstatus } = useGetProviderAssociatedToPatientListModalQuery(id, { refetchOnMountOrArgChange: true })
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType = localStorage?.getItem('user_type') !== null ? localStorage.getItem('user_type') : sessionStorage.getItem('user_type')

    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-dashboard-send-provider-alert');
        } else {
            setQueryParamsadmin('type=corporate-dashboard-send-provider-alert');
        }
    }, [userType]);

    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    /**
     * The function `handleOnChangeUserDetails` updates the state with a new value based on the
     * provided key.
     */
    const handleOnChangeUserDetails = (key, value) => {
        // Update the state with the new value
        setsendalertDetails(prevState => ({
            ...prevState,
            [key]: value
        }));
    };

    /**
     * The function `handleTabChange` resets pagination to default values when changing tabs and updates the
     * patient tab name.
     */
    const handleTabChange = (tabName) => {
        // Reset pagination to default values when changing tabs
        setSearchParams({
            tabname: tabName,
            page_number: 1,
            limit: 15
        })
        setPatientTabName(tabName)
        dispatch(resetDeviceAlertDashboardSearch());
        setIsAdvancedSearchOpen(false);
    }

    const handlePatientView = () => {
        let params = Object.fromEntries(searchParams);
        params['view'] = data?.[0]?._id
        setSearchParams({ ...params })
        dispatch(resetDeviceAlertDashboardSearch())
        setIsAdvancedSearchOpen(false);
    }

    const handleOpenAlertModal = () => {
        let array = [];
        if (providerList?.data.length > 0) {
            providerList.data.map((item) => {
                if (item.providerUserData.send_alert === true) {
                    array.push(item.providerUserData.user_id)
                }
            })
        }
        setsendalertDetails(prevState => ({
            ...prevState,
            recepient_details: array
        }));
        setConfirmation(true)
        dispatch(resetDeviceAlertDashboardSearch())
        setIsAdvancedSearchOpen(false);
    }

    const handleReadingTypeSelect = (user_id) => {
        setsendalertDetails((prev) => {
            // Check if the user_id is already in the array
            const isItemSelected = prev.recepient_details.includes(user_id);

            // Create a new array to hold the updated monitor_list
            let updatedMonitorList;

            if (isItemSelected) {
                // If the item is already selected, remove it
                updatedMonitorList = prev.recepient_details.filter(id => id !== user_id);
            } else {
                // If the item is not selected, add it
                updatedMonitorList = [...prev.recepient_details, user_id];
            }
            return {
                ...prev,
                recepient_details: updatedMonitorList
            };
        });
    }

    function handleSendButton() {
        const hasEmptyFields = () => {
            let isFieldsEmpty = false
            if (
                sendalertDetails.recepient_details.length === 0 ||
                !sendalertDetails?.alert_priority ||
                sendalertDetails?.alert_message === ""
            ) {
                isFieldsEmpty = true;
            }
            return isFieldsEmpty;
        };
        if (hasEmptyFields()) {

            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        }
        setConfirmationState(true);
        setConfirmation(true);
    }

    const obj = []
    // handle send alert
    const handleSendAlert = async () => {
        setalertloading(true);
        if (providerList?.data.length > 0) {
            providerList.data.map((item) => {
                if (sendalertDetails?.recepient_details?.includes(item.providerUserData.user_id)) {
                    obj.push(
                        { "recepient_id": item.providerUserData.user_id, "recepient_name": `${item.providerUserData?.first_name || ''} ${item.providerUserData?.last_name || ''}` }
                    )
                }
            })
        }
        let body =
        {
            "alert_priority": sendalertDetails.alert_priority,
            "alert_message": sendalertDetails.alert_message,
            "patient_id": id,
            "recepient_details": obj,
        }
        setConfirmationState(true);
        setConfirmation(true) // Set loading to false once
        setConfirmationTableState(false);
        const response = await sendAlert(body)
        if (response.error) {
            setalertloading(false);
            setConfirmationState(false);
            setConfirmation(false)
            setConfirmationTableState(false);
            setToastErrorMessage(response.error.data.message);
        }
        else {
            setToastmessage(response.data.message)
            setalertloading(false);
            setConfirmationState(false);
            setConfirmation(false)
            setConfirmationTableState(true);
        }
    }

    const handleContinueButton = async () => {
        setLoading(true);
        setConfirmationTableState(false)
        setLoading(false);
        setEmptyField(false);
        setsendalertDetails(prevState => ({
            ...prevState,
            alert_priority: '',
            alert_message: '',
            recepient_details: []// Clear alert_priority while keeping other fields intact

        }));
    }

    useEffect(() => {
        let array = [];
        if (providerList?.data.length > 0) {
            providerList.data.map((item) => {
                if (item.providerUserData.send_alert === true) {
                    array.push(item.providerUserData.user_id)
                }
            })
        }
        setsendalertDetails(prevState => ({
            ...prevState,
            recepient_details: array
        }));

    }, [providerList])

    const handleOnSubmit = (e) => {

        e.preventDefault();

        let searchString = '';

        // Utility function to handle __NULL__ logic for search values
        const formatSearchValue = (value) => {
            const trimmedValue = value.trim();
            return trimmedValue === '-' ? '__NULL__' : trimmedValue;
        };

        // Check for `device_id` and `device_id_inverse` conditions
        if (deviceDashboardSearch?.device_id && deviceDashboardSearch.device_id.trim() !== '') {
            const deviceIdPrefix = deviceDashboardSearch.device_id_inverse ? 'ne:' : '';
            const formattedDeviceId = formatSearchValue(deviceDashboardSearch.device_id);
            searchString += `device_id=${deviceIdPrefix}${encodeURIComponent(formattedDeviceId)};`;
        }

        // Check for `threshold` and `threshold_inverse` conditions
        if (deviceDashboardSearch?.threshold && deviceDashboardSearch.threshold.trim() !== '') {
            const thresholdPrefix = deviceDashboardSearch.threshold_inverse ? 'ne:' : '';
            const formattedThreshold = formatSearchValue(deviceDashboardSearch.threshold);
            searchString += `threshold=${thresholdPrefix}${encodeURIComponent(formattedThreshold)};`;
        }

        // Check for `reading` and `reading_inverse` conditions
        if (deviceDashboardSearch?.reading && deviceDashboardSearch.reading.trim() !== '') {
            const readingsPrefix = deviceDashboardSearch.reading_inverse ? 'ne:' : '';
            const formattedReadings = formatSearchValue(deviceDashboardSearch.reading);
            searchString += `reading=${readingsPrefix}${encodeURIComponent(formattedReadings)};`;
        }

        // check for alert_type field
        if (deviceDashboardSearch?.alert_type) {
            const alertTypePrefix = deviceDashboardSearch.alert_type_inverse ? 'ne:' : '';
            const formattedAlertType = formatSearchValue(deviceDashboardSearch.alert_type);
            searchString += `alert_type=${alertTypePrefix}${encodeURIComponent(formattedAlertType)};`;
        }

        // check for reading_type field
        if (deviceDashboardSearch?.reading_type) {
            const readingTypePrefix = deviceDashboardSearch.reading_type_inverse ? 'ne:' : '';
            const formattedReadingType = formatSearchValue(deviceDashboardSearch.reading_type)
                .toLowerCase()
                .replace(/\s+/g, '_');
            searchString += `reading_type=${readingTypePrefix}${encodeURIComponent(formattedReadingType)};`;
        }

        // check for reading_details field
        if (deviceDashboardSearch?.reading_details) {
            const readingDetailsPrefix = deviceDashboardSearch.reading_details_inverse ? 'ne:' : '';
            const formattedReadingDetails = formatSearchValue(deviceDashboardSearch.reading_details);
            searchString += `reading_details=${readingDetailsPrefix}${encodeURIComponent(formattedReadingDetails)};`;
        }

        const { measurement_day, measurement_month, measurement_year } = deviceDashboardSearch || {};

        // Check if only some of the fields are filled
        const isPartialDateFilled =
            (measurement_day && (!measurement_month || !measurement_year)) ||
            (measurement_month && (!measurement_day || !measurement_year)) ||
            (measurement_year && (!measurement_day || !measurement_month));

        if (isPartialDateFilled) {
            setDatePartialFilled(true);
            return;
        } else if (
            measurement_day === '--' &&
            measurement_month === '--' &&
            measurement_year === '----'
        ) {
            // All fields contain dashes, send __NULL__
            const measurementDatePrefix = deviceDashboardSearch.measurement_date_inverse ? 'ne:' : '';
            searchString += `day_in_timezone=${measurementDatePrefix}__NULL__;`;
        } else if (measurement_day && measurement_month && measurement_year) {
            // Ensure date is in 'YYYY-MM-DD' format
            const dateStr = `${measurement_year}-${String(measurement_month).padStart(2, '0')}-${String(measurement_day).padStart(2, '0')}`;

            // Add epoch to search string (or process it as needed)
            const measurementDatePrefix = deviceDashboardSearch.measurement_date_inverse ? 'ne:' : '';
            searchString += `day_in_timezone=${measurementDatePrefix}${dateStr};`;
        }
        // Remove trailing ';' if present
        if (deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('__NULL__') && deviceDashboardSearch.acknowledged_id_inverse === "true") {
            searchString += `acknowledged_by=__NULL__`
        } else if (deviceDashboardSearch?.acknowledged_id.includes('__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && deviceDashboardSearch.acknowledged_id_inverse === "true") {
            searchString += `acknowledged_by=ne:__NULL__`
        } else if (deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('__NULL__')) {
            searchString += `acknowledged_by=ne:__NULL__`
        } else if (deviceDashboardSearch?.acknowledged_id.includes('__NULL__') && !deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__')) {
            searchString += `acknowledged_by=__NULL__`
        } else if (deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && deviceDashboardSearch?.acknowledged_id.includes('__NULL__')) {
            searchString += `acknowledged_by=ne:__NULL__;acknowledged_by=__NULL__;`
        } else if ((deviceDashboardSearch?.acknowledged_id.includes('ne:__NULL__') && deviceDashboardSearch?.acknowledged_id.includes('__NULL__')) && deviceDashboardSearch.acknowledged_id_inverse === "true") {
            searchString += `acknowledged_by=__NULL__;acknowledged_by=ne:__NULL__;`
        }

        searchString = searchString.endsWith(';') ? searchString.slice(0, -1) : searchString;

        // Merge all search parameters into a single object
        const currentParams = Object.fromEntries(searchParams); // Get existing params
        const newParams = {
            ...currentParams, // Preserve existing params (limit, sort, etc.)
            search: searchString || '', // Add search string
            search_mode: deviceDashboardSearch.match === false ? 'and' : 'or', // Add search mode
            page_number: 1, // Reset page number on new search
            limit: currentParams.limit || '15', // Keep limit or set default
        };

        // Remove empty search key if search string is empty
        if (!newParams.search) delete newParams.search;


        // Update all searchParams in one go to avoid multiple re-renders or API calls
        setSearchParams(newParams);
        setisSortSelected(false)
        dispatch(setDeviceAlertDashboardSearchApplied());
    };

    // On mount, check search params and set the active tab
    useEffect(() => {
        const tabFromParams = searchParams.get('tabname') || 'device_alerts';
        setPatientTabName(tabFromParams);
    }, [searchParams]); // Runs whenever searchParams change

    return (
        <>
            {searchParams?.get('view') !== null ? <ViewPatient isDashboard={true} isOrganization={false} patient_id={searchParams?.get('view')} patientID={data?.[0]} /> : <div id={"patient_main_div"} className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={'Dashboard'} />
                {wellnessFetching && status !== "fulfilled" ? (
                    <CustomOverlay
                        Active
                        text="Loading Patient Details..."
                        classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? "opened-sidebar-config" : "system_config_overlay"
                        }`}
                    />
                ) : status === "rejected" || wellnessStatus === "rejected" ? (
                    wellnessError?.status === 404 ? (
                        <div className="bg-white rounded-lg py-[12px] px-[30px] h-customh3">
                            <PermissionErrorEmptyScreen
                                message="You don't have access to the organization or subdivision"
                                height="h-full"
                            />
                        </div>
                    ) : (
                        <SearchEmptyScreen text="No data found" />
                    )
                ) : (
                    <div className="bg-white rounded-lg py-[12px] px-[30px] h-customh3">

                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='flex justify-between items-center xl:mb-0 mb-[22px]'>
                                    <div className="flex items-center">
                                        <Link data-testid="list-alerts" to={("/dashboard")} onClick={() => dispatch(handleSidebarAnimation(false))} state={Array.isArray(location.state) ? '' : location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Alerts</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                        <h1 className="text-sm font-normal text-[#008586]">View Patient</h1>
                                    </div>
                                    {<div className="flex items-center">
                                        <button type="button" id="welleness_check"
                                            onClick={() => { handlePatientView() }}
                                            data-testid="view-details"
                                            className={`py-2 px-4 flex items-center text-lg font-normal text-[#fff] 
                                    rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                        focus:bg-[#863B50] disabled:bg-[#777C88] ml-2 ${patientTabName === "administrative_notes" || patientTabName === "medical_notes" ? "xl:block hidden" : "block"}`}>
                                            View Patient Details
                                        </button>

                                        <button type="button"
                                            onClick={() => handleOpenAlertModal()}
                                            data-testid="send-alert"
                                            className={`py-2 px-4 flex items-center text-lg font-normal text-[#fff] 
                                        rounded-[16px] bg-[#972E4C] hover:bg-[#AB556E] min-w-max
                                            focus:bg-[#863B50] disabled:bg-[#777C88] xl:ml-4 ml-2`}>
                                            Send Provider Alerts
                                        </button>
                                        {
                                            userType !== 'super-admin' &&
                                            <div onClick={() => setHelpGuideModel(true)} className='ml-2 min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </div>
                                        }
                                    </div>}
                                </div>

                                <div>
                                    <div className="flex justify-between items-center xl:pr-11 pr-9">
                                        <div className="flex items-center">
                                            <p className="text-xl font-semibold text-[#000000]" data-testid="patient-name">{data?.[0]?.first_name || ''} {data?.[0]?.middle_name || ''} {data?.[0]?.last_name || ''}</p>
                                            <p className="text-sm font-normal text-[#000000] px-2">{data?.[0]?.patient_id}</p>
                                            {data?.[0]?.status == 'inactive' ? <p className="px-3 py-1.5 bg-[#C5C9DA] rounded-[16px] text-sm font-semibold text-[#52555D]">Inactive</p> : <p className="px-3 py-1.5 bg-[#CCE7E7] rounded-[16px] text-sm font-semibold text-[#006A6B]">Active</p>
                                            }
                                        </div>
                                    </div>
                                    {!wellnessFetching && wellnessDetails?.patientData?.wellness_reading_count !== '-' && (<><div><p className='text-[14px] leading-[20px] text-[#031624] font-normal mt-[16px]'>{`Current Readings Days = ${wellnessDetails?.patientData?.vital_reading_count}, ${wellnessDetails?.patientData?.vital_pending_days} Days left in cycle (Minimum ${wellnessDetails?.patientData?.vital_number_of_time_periods} in ${wellnessDetails?.patientData?.vital_time_period} )`}</p>

                                        <p className='text-[14px] leading-[20px] text-[#031624] font-normal mt-[16px]'>{`Current Qualified Wellness Contacts = ${wellnessDetails?.patientData?.wellness_reading_count}, ${wellnessDetails?.patientData?.wellness_pending_days} Days left in cycle (Minimum ${wellnessDetails?.patientData?.wellness_number_of_time_periods} contacts, ${wellnessDetails?.patientData?.number_of_minutes} mins each, in ${wellnessDetails?.patientData?.wellness_time_period} ).`}</p></div></>)}
                                    <div className='mt-4'>
                                        <div className={`flex ${'pb-2'} overflow-x-auto overflow-y-hidden ${'scrollBar-hidden'} border-b border-[#E7CBD2] w-full mr-6 pr-1`}>
                                            <button
                                                data-testid="device-alerts-tab"
                                                onClick={() => { handleTabChange('device_alerts'), setSearchParams('tabname=device_alerts') }}
                                                disabled={isStateLoading}
                                                className={`px-2.5 pt-2.5 min-w-fit text-base font-semibold ${patientTabName === 'device_alerts' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'device_alerts' ? 'patient_tab' : ''}`}
                                            >
                                                Device Alerts
                                            </button>
                                            <button
                                                id={'provider_alerts'}
                                                data-testid={'provider_alerts'}
                                                disabled={isStateLoading}
                                                onClick={() => { handleTabChange('provider_alerts'), setSearchParams('tabname=provider_alerts') }}
                                                className={`px-2 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'provider_alerts' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'provider_alerts' ? 'patient_tab' : ''}`}
                                            >
                                                Provider Alerts
                                            </button>
                                            <button
                                                id={'device_details'}
                                                data-testid={'provider-list-tab'}
                                                disabled={isStateLoading}
                                                onClick={() => { handleTabChange('provider_list'), setSearchParams('tabname=provider_list') }}
                                                className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'provider_list' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'provider_list' ? 'patient_tab' : ''}`}
                                            >
                                                Provider List
                                            </button>
                                            <button
                                                id={'device_list'}
                                                disabled={isStateLoading}
                                                onClick={() => { handleTabChange('device_list'), setSearchParams('tabname=device_list') }}
                                                className={`px-2.5 pt-2.5 min-w-fit ml-[46px] text-base font-semibold ${patientTabName === 'device_list' ? 'text-[#972E4C]' : 'text-[##030E06] '} relative ${patientTabName === 'device_list' ? 'patient_tab' : ''}`}
                                            >
                                                Device List
                                            </button>
                                        </div>
                                    </div>
                                    {patientTabName === "device_alerts" &&
                                        <DeviceAlertList wellnessDetails={wellnessDetails} wellnessFetching={wellnessFetching} setIsStateLoading={setIsStateLoading} />
                                    }
                                    {patientTabName === "provider_alerts" &&
                                        <ProviderAlertList patientId={id} setIsStateLoading={setIsStateLoading} />
                                    }
                                    {patientTabName === 'provider_list' &&
                                        <ProviderList patientId={id} setIsStateLoading={setIsStateLoading} />

                                    }
                                    {patientTabName === "device_list" &&
                                        <DeviceList patientId={id} setIsStateLoading={setIsStateLoading} />
                                    }
                                </div>
                            </div>
                        </motion.div>
                    </div>
                )}

            </div>}
            {/* send alert model */}
            {confirmation &&
                <AnimatedModel key="edit-model"
                    Children={
                        <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{ display: "block" }}>
                            <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                                <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px] pt-[24px] pb-5 relative">
                                    <div className="flex justify-between pb-[16px] ">
                                        <h1 className='text-2xl font-normal text-[#000]'>Alert Message</h1>
                                        <img
                                            onClick={() => {
                                                setConfirmation(false);
                                                setEmptyField(false);
                                                setsendalertDetails(prevState => ({
                                                    ...prevState,
                                                    alert_priority: '',
                                                    alert_message: '',
                                                    recepient_details: []// Clear alert_priority while keeping other fields intact

                                                }));
                                            }} src='/images/close_icon.svg' className='cursor-pointer' />
                                    </div>

                                    <div className='  border border-[#C5C9DA] rounded-[8px] p-[24px] overflow-auto overflow-x-hidden scrollbar_grayw6 h-customh12'>
                                        <div className='w-[425px]  mb-[32px]'>
                                            <p className="text-[12px] leading-[16px] font-semibold text-[#000000] pb-[6px]">Recipient</p>

                                            <ProviderDropdown
                                                id={`monitor_name`}
                                                data_testid={""}
                                                placeholder={`${sendalertDetails.recepient_details.length === 0 ? "Select recepient" : `${sendalertDetails.recepient_details.length} selected`}`}
                                                disabled={false}
                                                options={providerList && providerList.data}
                                                handleReadingTypeSelect={handleReadingTypeSelect}
                                                deviceTemplateDetails={sendalertDetails}
                                                sendalertDetails={sendalertDetails}
                                                emptyField={emptyField && sendalertDetails.recepient_details.length === 0}
                                            />
                                        </div>
                                        <div className="mb-[32px]">
                                            <p className="text-[12px] leading-[16px] font-semibold text-[#000000] pb-[10px]">Alert Priority</p>
                                            <div className='w-full'>
                                                <div className='flex items-center pt-[7px]'>
                                                    <>
                                                        <div className="relative flex items-center">
                                                            <button
                                                                id={'high'}
                                                                data-testid="high"
                                                                onClick={() => handleOnChangeUserDetails("alert_priority", 'High')}
                                                                type='button' className={`w-[157px] ${sendalertDetails.alert_priority === 'High' ? 'bg-[#EDD7E1]' : 'bg-white'} py-2 border hover:bg-[#EDD7E1] border-[#972E4C] h-fit rounded-[16px] flex items-center justify-center`}>
                                                                <span className='text-lg font-semibold text-center text-[#972E4C]' data-testid="high-btn" id="high">High</span>
                                                            </button>
                                                        </div>
                                                        <div className="relative ml-[16px] flex items-center">
                                                            <button
                                                                data-testid="medium"
                                                                onClick={() => handleOnChangeUserDetails("alert_priority", 'Medium')}
                                                                type='button' className={`w-[157px] ${sendalertDetails.alert_priority === 'Medium' ? 'bg-[#EDD7E1]' : 'bg-white'}  py-2 border hover:bg-[#EDD7E1] border-[#972E4C] h-fit rounded-[16px] flex items-center  justify-center`}>
                                                                <span className=' text-lg text-center font-semibold text-[#972E4C]' data-testid="medium-btn" id="medium">Medium</span>
                                                            </button>
                                                        </div>
                                                    </>
                                                </div>
                                            </div>
                                        </div>
                                        <p className="text-[12px] leading-[16px] font-semibold text-[#000000] pb-[12px]">Alert Message</p>
                                        <div className="h-[202px]">
                                            <TextArea
                                                PatientNotes={false}
                                                dataTestid={'alert_message'}
                                                htmlFor={'alert_message'}
                                                id={'alert_message'}
                                                value={sendalertDetails?.alert_message}
                                                placeholder={'Type message here...'}
                                                emptyField={emptyField && sendalertDetails?.alert_message === "" && sendalertDetails?.alert_message === undefined}
                                                handleOnChangeInput={handleOnChangeUserDetails}
                                                handleOnCLickActivate={''}
                                            />
                                        </div>
                                    </div>
                                    <div className='px-2.5 flex justify-end pt-3'>
                                        <button
                                            loading={loading}
                                            disabled={sendalertDetails?.alert_message === "" || sendalertDetails?.alert_message.trim() === "" || sendalertDetails.recepient_details.length === 0 || sendalertDetails.alert_priority === ""}
                                            id={'send'}
                                            onClick={handleSendButton}
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>Send</button>
                                    </div>
                                </div>
                            </div>
                            {
                                toastErrorMessage !== '' && <Toast
                                    message={toastErrorMessage}
                                    type='error'
                                    setToastmessage={setToastErrorMessage}
                                    modal={true}
                                />
                            }
                        </div>
                    }
                />
            }
            {/* send alet confirmation state */}
            {confirmationState && (
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            handleOnCLickActivate={handleSendAlert}
                            handleClose={() => { setConfirmationState(false) }}
                            tittle={'Send Alert Message'}
                            message={'Are you sure you want to send alert message?'}
                            buttonName={"Yes"}
                            CancelButton={'No'}
                            disabled={sendalertloading}
                            loadingActivation={sendalertloading}
                        />
                    }
                />
            )}
            {/* table deatilsssssss */}
            {confirmationTablestate &&
                <AnimatedModel key="edit-model"
                    Children={
                        <div data-te-modal-init="" className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto overflow-x-hidden outline-none bg-black bg-opacity-50" id="modalforDeactivate" tabIndex="-1" aria-labelledby="modalforDeactivateTitle" aria-modal="true" role="dialog" data-te-open="true" style={{ display: "block" }}>
                            <div ref={outsideClickRef} data-te-modal-dialog-ref="" className="pointer-events-none relative flex min-h-[calc(100vh-1rem)] w-auto translate-y-[-50px] translate-x-[10px] items-center opacity-1 transition-all duration-300 ease-in-out min-w-[943px] m-auto max-w-[943px] pt-[80px]">
                                <div className="pointer-events-auto flex w-full flex-col rounded-[16px] border-none bg-white bg-clip-padding text-current shadow-lg outline-none min-w-[943px] mx-auto max-w-[943px] px-[24px]  pb-5 relative">
                                    <img
                                        onClick={() => {
                                            setConfirmationTableState(false);
                                            setEmptyField(false);
                                            setsendalertDetails(prevState => ({
                                                ...prevState,
                                                alert_priority: '',
                                                alert_message: '',
                                                recepient_details: []// Clear alert_priority while keeping other fields intact
                                            }));
                                        }} src='/images/close_icon.svg' className='cursor-pointer absolute top-[30px] right-[27px]' />
                                    <div className="h-[500px] overflow-auto scrollbar_gray">
                                        <div>
                                            {providerList.data.some((Provider) => {
                                                const userId = Provider?.providerUserData?.user_id;
                                                const emailaddress = Provider?.providerUserData?.preference_mode === 'email'
                                                    ;
                                                const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && emailaddress;
                                                return isUserIdIncluded;
                                            }) && (
                                                <>
                                                    <div className="flex mt-[24px] justify-between pb-[11px]">
                                                        <h1 className='text-2xl font-normal text-[#000]'>Email Sent</h1>
                                                    </div>
                                                    <h1 className="text-[16px] leading-[21px] pb-[7px] text-[#000000] font-semibold">Email has been sent to the following providers:</h1>
                                                </>
                                            )}

                                            {providerList.data.map((Provider, index) => {
                                                const userId = Provider?.providerUserData?.user_id;
                                                const emailaddress = Provider?.providerUserData?.preference_mode === 'email';
                                                const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && emailaddress;
                                                if (isUserIdIncluded) {
                                                    return (
                                                        <><div className="max-h-[300px] overflow-auto scrollbar_gray" key={index}>
                                                            <p className="text-[16px] leading-normal font-normal text-[#000000]">
                                                                {Provider?.providerUserData?.email_address} ({Provider?.providerUserData?.first_name || ''} {Provider?.providerUserData?.last_name || ''})
                                                            </p>
                                                        </div></>
                                                    );
                                                }
                                                return null; // Return null for rows that don't match the condition
                                            })}
                                        </div>
                                        {/* contains only mobile number */}
                                        <div>
                                            {providerList.data.some((Provider) => {
                                                const userId = Provider?.providerUserData?.user_id;
                                                const mobilenumber = Provider?.providerUserData?.preference_mode === 'call';
                                                const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && mobilenumber;
                                                return isUserIdIncluded;
                                            }) && (
                                                <>
                                                    <div className="flex mt-[24px] justify-between pb-[11px]">
                                                        <h1 className='text-2xl font-normal text-[#000]'>Please Call</h1>
                                                    </div>
                                                    <h1 className="text-[16px] leading-[21px] text-[#000000] font-semibold">Please call the following providers:</h1>
                                                </>
                                            )}
                                            <>
                                                {providerList.data.some((Provider) => {
                                                    const userId = Provider?.providerUserData?.user_id;
                                                    const mobilenumber = Provider?.providerUserData?.preference_mode === 'call';
                                                    const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && mobilenumber;
                                                    return isUserIdIncluded;
                                                }) && (
                                                    <div class='border border-[#EDD7E1] mt-4 mb-4 mr-2 rounded pb-2'>
                                                        <table id="organization_table" aria-label="Outside Table" class="w-full table-fixed">
                                                            <thead>
                                                                <tr class="h-[38px] w-full bg-[#EDD7E1] rounded-sm">
                                                                    <th class="px-[18px] py-2 rounded-tl-sm rounded-bl-sm">
                                                                        <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Provider ID</span>
                                                                    </th>
                                                                    <th id="id" class="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                        <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Provider Name</span>
                                                                    </th>
                                                                    <th id="id" class="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                        <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Main Number</span>
                                                                    </th>
                                                                    <th id="id" class="px-[18px] py-2 min-w-[100px] rounded-tl-sm rounded-bl-sm">
                                                                        <span class="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number</span>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {providerList.data.map((Provider, index) => {
                                                                    const userId = Provider?.providerUserData?.user_id;
                                                                    const mobilenumber = Provider?.providerUserData?.preference_mode === 'call';
                                                                    const isUserIdIncluded = sendalertDetails?.recepient_details.includes(userId) && mobilenumber;
                                                                    if (isUserIdIncluded) {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] break-words" style={{ 'lineBreak': 'anywhere' }}>
                                                                                    {Provider?.providerUserData?.user_id}
                                                                                </td>
                                                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] break-words" style={{ 'lineBreak': 'anywhere' }}>
                                                                                    {Provider?.providerUserData?.first_name || ''} {Provider?.providerUserData?.last_name || ''}
                                                                                </td>
                                                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] break-words" style={{ 'lineBreak': 'anywhere' }}>
                                                                                    {Provider?.providerUserData?.main_no_country_code} {formatMobileNumber(Provider?.providerUserData?.main_number)}
                                                                                </td>
                                                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624] break-words" style={{ 'lineBreak': 'anywhere' }}>
                                                                                    {Provider?.providerUserData?.mob_no_country_code} {formatMobileNumber(Provider?.providerUserData?.mobile_number)}
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    }
                                                                    return null; // Return null for rows that don't match the condition
                                                                })}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}
                                            </>
                                        </div>
                                    </div>
                                    <div className='px-2.5 flex justify-end pt-3'>
                                        <button
                                            loading={loading}
                                            id={'continue'}
                                            onClick={handleContinueButton}
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                                    bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>Continue</button>
                                    </div>
                                </div>
                                {
                                    toastErrorMessage !== '' && <Toast
                                        message={toastErrorMessage}
                                        type='error'
                                        setToastmessage={setToastErrorMessage}
                                        modal={true}
                                    />
                                }
                            </div>
                        </div>
                    }
                />
            }
            {(helpGuideModel && helpguidestatus === "fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
            }
            {isAdvancedSearchOpen && searchParams?.get('limit') && !searchParams?.get('target_user_name') &&
                <DeviceAlertDashboardSearch
                    handleOnSubmit={handleOnSubmit}
                    emptyField={datePartialFilled}
                    setEmptyField={setDatePartialFilled} />
            }
        </>
    )
}